import store from "../store";
import { actionTypes } from "./saga";

export function setWorkforceData(data) {
  store.dispatch({
    type: actionTypes.SET_WORKFORCE_DATA,
    payload: {
      data: data
    }
  });
}

export function getAllWorkforceSummaryData() {
  store.dispatch({
    type: actionTypes.GET_ALL_WORKFORCE_SUMMARY_DATA
  });
}

export function setWorkforceResults(data, count) {
  store.dispatch({
    type: actionTypes.SET_WORKFORCE_RESULTS,
    payload: {
      data: data,
      count: count
    }
  });
}

export function addCaptureSummaryData(data) {
  store.dispatch({
    type: actionTypes.ADD_CAPTURE_SUMMARY_DATA,
    payload: { data: data }
  });
}

export function getRolesData() {
  store.dispatch({
    type: actionTypes.GET_ROLES_DATA
  });
}

export function addRolesToSelectedEmployee(employeeId, roles) {
  store.dispatch({
    type: actionTypes.ADD_ROLES_DATA,
    payload: { roles: roles, documentId: employeeId }
  });
}

export function createEmployee(data, file) {
  store.dispatch({
    type: actionTypes.CREATE_WORKFORCE,
    payload: { data: data, file: file }
  });
}
export function editEmployee(data) {
  store.dispatch({
    type: actionTypes.EDIT_WORKFORCE,
    payload: { data: data }
  });
}

export function archiveEmployee(documentId) {
  store.dispatch({
    type: actionTypes.ARCHIVE_WORKFORCE,
    payload: { documentId: documentId }
  });
}

export function unarchiveEmployee(documentId) {
  store.dispatch({
    type: actionTypes.UNARCHIVE_WORKFORCE,
    payload: { documentId: documentId }
  });
}

export function assignLocations(employeeId, locations) {
  store.dispatch({
    type: actionTypes.ASSIGN_LOCATIONS,
    payload: { employeeId, locations }
  });
}

export function updateProceduresToWorkforce(employeeId, procedures) {
  store.dispatch({
    type: actionTypes.UPDATE_PROCEDURES_TO_WORKFORCE,
    payload: { employeeId, procedures }
  });
}

export function getOperationsData() {
  store.dispatch({
    type: actionTypes.GET_OPERATIONS_DATA
  });
}